document.addEventListener("DOMContentLoaded", function () {
  const $dropdown = $(".dropdown");
  const $dropdownToggle = $(".dropdown-toggle");
  const $dropdownMenu = $(".dropdown-menu");
  const showClass = "show";

  // Function to setup mobile dropdown handlers
  function setupMobileDropdowns() {
    if (window.matchMedia("(max-width: 1199px)").matches) {
      // Remove existing handlers to prevent duplicates
      $(document).off("click.mobileDropdown", "#mobile_nav .mobile-nav__toggle");
      
      // Mobile nav dropdowns - use event delegation with new class names
      $(document).on("click.mobileDropdown", "#mobile_nav .mobile-nav__toggle", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $this = $(this);
        const $item = $this.closest(".mobile-nav__item");
        const $hasChildren = $item.closest(".mobile-nav__has-children");
        const $dropdown = $item.find(".mobile-nav__dropdown").first();
        
        // Toggle the show class on the dropdown and parent item
        $dropdown.toggleClass("show");
        $item.toggleClass("show");
        if ($hasChildren.length) {
          $hasChildren.toggleClass("show");
        }
        $this.attr("aria-expanded", $dropdown.hasClass("show") ? "true" : "false");
        
        // Close other open dropdowns at the same level
        $item.siblings(".mobile-nav__item").find(".mobile-nav__dropdown").removeClass("show");
        $item.siblings(".mobile-nav__item").removeClass("show");
      });
    } else {
      // Remove handlers when on desktop
      $(document).off("click.mobileDropdown", "#mobile_nav .mobile-nav__toggle");
    }
  }

  // Setup on initial load
  setupMobileDropdowns();

  $(window).bind("load resize", function () {
    if (this.matchMedia("(min-width: 1200px)").matches) {
      // Only set overflow if nav is not open
      if (!$("body").hasClass("nav-open")) {
        $("body").css("overflow", "visible");
      }
      $dropdown.hover(
        function () {
          const $this = $(this);
          $this.addClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "true");
          $this.find($dropdownMenu).addClass(showClass);
        },
        function () {
          const $this = $(this);
          $this.removeClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "false");
          $this.find($dropdownMenu).removeClass(showClass);
        }
      );
    } else {
      $dropdown.off("mouseenter mouseleave");
    }

    if (this.matchMedia("(max-width: 1199px)").matches) {
      // Remove existing handlers to prevent duplicates
      $("#main_nav .dropdown-toggle").off("click.dropdown");
      $("#mobile_nav .dropdown-toggle").off("click.dropdown");

      // Desktop nav dropdowns
      $("#main_nav .dropdown-toggle").on("click.dropdown", function (e) {
        e.stopImmediatePropagation();
        if ($(this).attr("aria-expended") == false) {
          $(this).attr("aria-expended", "true");
          $(this).children(".dropdown-menu").toggleClass("show");
        } else {
          $(this).attr("aria-expended", "false");
          $(this).find(".dropdown-menu").toggleClass("show");
        }
      });

      // Mobile nav dropdowns handled by setupMobileDropdowns function
      setupMobileDropdowns();
    } else {
      // Remove handlers when on desktop
      $("#main_nav .dropdown-toggle").off("click.dropdown");
      setupMobileDropdowns(); // This will remove mobile handlers
    }
  });

  // Scroll-based sticky class for homepage template
  if ($("body").hasClass("page-template-tpl_homepage")) {
    const $stickyTop = $(".sticky-top");
    const scrollThreshold = 50; // pixels to scroll before switching to sticky

    function handleScroll() {
      const scrollTop = $(window).scrollTop();
      
      if (scrollTop > scrollThreshold) {
        $stickyTop.addClass("is-scrolled");
      } else {
        $stickyTop.removeClass("is-scrolled");
      }
    }

    // Initial check
    handleScroll();

    // Throttle scroll events for better performance
    let ticking = false;
    $(window).on("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }
});
